<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions">
      <div slot="content-buttons">
        <Button _key="btnCustomerCategoryCreate" title="Categoria" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Categoria" :width="500" :height="250" v-show="showModal('customerCategoryCreateUpdate')">
      <CategoryCustomerCreateUpdate />
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import CategoryCustomerCreateUpdate from "@/components/modules/crm/category-customer/CategoryCustomerCreateUpdate.vue";

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CustomerCategoryView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    CategoryCustomerCreateUpdate,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/crm/category-customer/get-all",
        urlDeleteAllApi: "/api/v1/crm/category-customer/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "customerCategoryUpdate",
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/crm/category-customer/delete", method: "delete", },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("customerCategoryCreateUpdate");
      this.addEvent({ name: "customerCategoryCreate" });
      this.removeLoading(["btnCustomerCategoryCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "customerCategoryUpdate")
          this.openModal("customerCategoryCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
